import { render, staticRenderFns } from "./CampaignClientsPopUp.vue?vue&type=template&id=2e7d53bd&scoped=true&"
import script from "./CampaignClientsPopUp.vue?vue&type=script&lang=js&"
export * from "./CampaignClientsPopUp.vue?vue&type=script&lang=js&"
import style0 from "./CampaignClientsPopUp.vue?vue&type=style&index=0&id=2e7d53bd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../../bankari hypo/BankariBroker/frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e7d53bd",
  null
  
)

export default component.exports